import { useMemo } from 'react';

import { Area, InvisibleArea, useThemeColor } from '@cast/design-system';

import { inventoryWorkloadsChartZoomProps } from '../../../../_hooks/useInventoryWorkloadsChartZoomProps';
import { ResourceChart } from '../../../../_components/ui/ResourceChart';

import { ResourceImpactChartItem, ResourceImpactChartDataKey } from './_types';

import { chartDataSettings, DIFFERENCE_COLOR } from './_constants';

type Props = {
  data: ResourceImpactChartItem[];
  isLoading: boolean;
  isMetricDisabled: (key: ResourceImpactChartDataKey) => boolean;
  unit: string;
  timeZone: string;
};

const ImpactInvisibleArea = InvisibleArea<ResourceImpactChartItem>;
const ImpactArea = Area<ResourceImpactChartItem>;

export const ImpactChart = ({
  data,
  isLoading,
  isMetricDisabled,
  unit,
  timeZone,
}: Props) => {
  const differenceColor = useThemeColor(DIFFERENCE_COLOR);

  const displayDiffArea = useMemo(
    () => !isMetricDisabled('originalReq') && !isMetricDisabled('req'),
    [isMetricDisabled]
  );

  return (
    <ResourceChart<ResourceImpactChartItem>
      data={data}
      isLoading={isLoading}
      isMetricDisabled={(key) =>
        isMetricDisabled(key as ResourceImpactChartDataKey)
      }
      unit={unit}
      timeZone={timeZone}
      testId="impact-chart"
      chartDataSettings={chartDataSettings}
      zoomProps={inventoryWorkloadsChartZoomProps}
    >
      {displayDiffArea && (
        <>
          <ImpactInvisibleArea dataKey="req" stackId="diffStack" />
          <ImpactArea
            dataKey="diff"
            stackId="diffStack"
            activeDot={false}
            isAnimationActive={false}
            variant="hatched"
            fill={differenceColor}
            tooltipConfig={{
              displayName: 'Difference',
              unit,
            }}
          />
        </>
      )}
    </ResourceChart>
  );
};
